import customLogger from "../utils/customLogger.js";
import messages from "../utils/messages.js";
// Authentication service for handling API calls related to authentication

/**
 * Authenticate user with the server
 * @param {string} sk - Session key from URL
 * @param {string} apiSig - API signature from URL
 * @returns {Promise} - Promise resolving to the authentication token
 */
export const authenticate = async (sk, apiSig,companyId,userName,companyName ) => {
  try {
    // TODO: Make actual call to http://n8n.sentrihub.com/webhook/Authentication
    // The code below shows how the actual implementation would work,
    // but for testing purposes, we'll bypass the actual API call
    
    
    // This is the actual implementation that would be used in production

    /*** Get this URL from env file */
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://n8n.sentrihub.com/webhook';
    const { 
      REACT_APP_ENV
    } = process.env;

    const response = await fetch(`${API_BASE_URL}/Authentication?env=${encodeURIComponent(REACT_APP_ENV)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sk,
        api_sig: apiSig, 
        companyId,
        userName,
        companyName        
      })
    });

    if(response.ok) {
      const data = await response.json();
      //customLogger.log("zerobalance-dataprep -> AuthService -> authenticate -> Response from React to n8n",data)
      // Success response: Status 200 with token array
      if (response.status === 200 && data && data?.token) {
        return {
          success: true,
          token: data.token
        };
      }
    } else {
      const errorResponse = await response.json();
      customLogger.log("zerobalance-dataprep -> AuthService -> authenticate -> Error from n8n to react",errorResponse)
      // Handle error responses
      if (response.status === 400) {
        return {
          success: false,
          message: 'Bad Request: ' + (errorResponse.Description || messages.errors.MISSING_REQUIRED_PARAMS)
        };
      }
      
      if (response.status === 401) {
        return {
          success: false,
          message: 'Unauthorized: ' + (errorResponse.Description || messages.errors.AUTHENTICATION_FAILED)
        };
      }
      
      if (response.status === 500) {
        return {
          success: false,
          message: 'Server Error: ' + (errorResponse.Description || messages.errors.UNEXPECTED_ERROR)
        };
      }
      
      return {
        success: false,
        message: errorResponse.Description || messages.errors.AUTHENTICATION_FAILED
      };
    }
    
    
    // For testing purposes, we're using a simulated response
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    //customLogger.log(`Authentication params received - SK: ${sk}, API Signature: ${apiSig}`);
    
    // For testing: Check if this is a valid signature
    // We're considering "invalid_signature" as our test case for invalid auth
    if (sk && apiSig && apiSig !== 'invalid_signature') {
      //customLogger.log('Authentication successful!');
      return {
        success: true,
        token: `simulated_token_${Date.now()}`
      };
    }
    
    // Simulated failed authentication
    //customLogger.log('Authentication failed!');
    //console.error(`Invalid authentication detected. SK: ${sk}, API Signature: ${apiSig}`);
    return {
      success: false,
      message: 'Authentication failed - Invalid credentials'
    };
  } catch (error) {
    //console.error('Authentication error:', error);
    return {
      success: false,
      message: messages.errors.ERROR_WHILE_AUTHENTICATION
    };
  }
};

/**
 * Verify if the auth token is valid
 * @param {string} token - Authentication token to verify
 * @returns {Promise} - Promise resolving to verification result
 */
export const verifyToken = async (token) => {
  try {
    // TODO: Make actual call to verify token

    // For testing purposes, we're bypassing the actual call
    // Simulated token verification
    return {
      success: !!token,
      isValid: !!token
    };
  } catch (error) {
    //console.error('Token verification error:', error);
    return {
      success: false,
      message: messages.errors.ERROR_WHILE_AUTHENTICATION
    };
  }
};
